import { FC } from 'react';
import styled from 'styled-components';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { colors } from 'ui/theme';
import { GRID } from './constants';
import { HeaderCell } from './HeaderCell';

export const HEADER_ROW_TEST_ID = 'snippets-header-row';

const StyledHeaderRow = styled(HeaderGridRow)`
  && {
    min-width: fit-content;
    background: ${colors.white};
  }
`;

export const TABLE_COLS = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Total sends',
    value: 'TotalSent',
  },
  {
    label: 'Total clicks',
    value: 'TotalClicks',
  },
  {
    label: 'Unique clicks',
    value: 'UniqueClicks',
  },
  {
    label: 'Click rate',
    value: 'ClickRate',
  },
];

export const HeaderRow: FC = () => {
  return (
    <StyledHeaderRow gridLayout={GRID} data-test={HEADER_ROW_TEST_ID}>
      {TABLE_COLS.map((col) => (
        <HeaderCell key={col.value} column={col} />
      ))}
    </StyledHeaderRow>
  );
};
